import React from "react";
import "./footer.css";
import { BsLinkedin } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";

const Footer = () => {
  return (
    <footer>
      <a href="#" className="footer__logo">
        Sai Sriram Kamineni
      </a>
      <ul className="permalinks">
        <li>
          <a href="#">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#experience">Skills</a>
        </li>
        <li>
          <a href="#portfolio">Portfolio</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>
      <div className="footer__socials">
        <a href="https://www.linkedin.com/in/saisriram-kamineni/">
          <BsLinkedin />
        </a>
        <a href="https://github.com/SaiSriramKamineni">
          <FaGithub />
        </a>
      </div>
      <div className="footer__copyright">
        <small>&copy; Sai Sriram Kamineni. All rights reserved.</small>
      </div>
    </footer>
  );
};

export default Footer;
